import gbAntSelectPaginationMultiple from "./src/gb-ant-select-pagination-multiple.vue";
const gbAntSelectPaginationMultipleCompenet = function(Vue) {
  Vue.component(
    gbAntSelectPaginationMultiple.name,
    gbAntSelectPaginationMultiple
  );
};
export default gbAntSelectPaginationMultipleCompenet;
